class AddFundingPairModalController {
  constructor($uibModalInstance, $http, $rootScope, toastr, project) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.project = project || {};
    this.saving = false;
    this.selectedChargeCode = null;
    this.currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    this.model = {
      chargeCodeId: null,
      userId: null,
      fundedHours: null
    };
  }

  formatMoney(value) {
    return this.currencyFormatter.format(Number(value) || 0);
  }

  existingFundingKeys() {
    const keys = {};
    ((this.project && this.project.fundingBreakdown) || []).forEach((line) => {
      if (!line || !line.chargeCode || !line.user) {
        return;
      }
      keys[`${line.chargeCode.id}:${line.user.id}`] = true;
    });
    return keys;
  }

  hasExistingFunding(chargeCodeId, userId) {
    if (chargeCodeId == null || userId == null || chargeCodeId === '' || userId === '') {
      return false;
    }
    return !!this.existingFundingKeys()[`${chargeCodeId}:${userId}`];
  }

  availableChargeCodes() {
    const userId = this.model && this.model.userId;
    return ((this.project && this.project.chargeCodes) || []).filter((chargeCode) => {
      if (!userId) {
        return true;
      }
      return !this.hasExistingFunding(chargeCode.id, userId);
    });
  }

  availableUsers() {
    const chargeCodeId = this.model && this.model.chargeCodeId;
    return ((this.project && this.project.allTimeUsers) || []).filter((user) => {
      if (!chargeCodeId) {
        return true;
      }
      return !this.hasExistingFunding(chargeCodeId, user.id);
    });
  }

  onChargeCodeChanged() {
    const id = this.model && this.model.chargeCodeId;
    this.selectedChargeCode = ((this.project && this.project.chargeCodes) || [])
      .find((chargeCode) => String(chargeCode.id) === String(id)) || null;

    if (this.model.userId && this.hasExistingFunding(id, this.model.userId)) {
      this.model.userId = null;
    }
  }

  onUserChanged() {
    if (this.model.chargeCodeId && this.hasExistingFunding(this.model.chargeCodeId, this.model.userId)) {
      this.model.chargeCodeId = null;
      this.selectedChargeCode = null;
    }
  }

  isDuplicateSelection() {
    return this.hasExistingFunding(this.model && this.model.chargeCodeId, this.model && this.model.userId);
  }

  popRate() {
    return this.selectedChargeCode && this.selectedChargeCode.popRate;
  }

  laborRate() {
    return Number(this.popRate() && this.popRate().fullyBurdenedRate) || 0;
  }

  feeRate() {
    return Number(this.popRate() && this.popRate().feeRate) || 0;
  }

  fixedFeeBasisLabel() {
    const popRate = this.popRate();
    if (!popRate) {
      return '—';
    }
    if (!popRate.fixedFeeBasisId) {
      return 'No fixed fee basis linked';
    }
    const parts = [
      popRate.laborCategory && popRate.laborCategory.name,
      popRate.fixedFeeModLabel || null
    ].filter(Boolean);
    return parts.length ? parts.join(' · ') : ('Basis #' + popRate.fixedFeeBasisId);
  }

  estimatedLaborAmount() {
    return this.laborRate() * (Number(this.model && this.model.fundedHours) || 0);
  }

  estimatedFeeAmount() {
    return this.feeRate() * (Number(this.model && this.model.fundedHours) || 0);
  }

  estimatedTotalAmount() {
    return this.estimatedLaborAmount() + this.estimatedFeeAmount();
  }

  canSave() {
    const model = this.model || {};
    return !!(model.chargeCodeId
      && model.userId
      && model.fundedHours != null
      && model.fundedHours !== ''
      && Number(model.fundedHours) >= 0
      && !this.isDuplicateSelection()
      && !this.saving);
  }

  save() {
    if (!this.canSave() || !this.project || !this.project.id) {
      return;
    }
    if (this.isDuplicateSelection()) {
      this.toastr.error('Funding line items already exist for this charge code and user', 'ERROR');
      return;
    }

    this.saving = true;
    const payload = {
      chargeCodeId: Number(this.model.chargeCodeId),
      userId: Number(this.model.userId),
      fundedHours: Number(this.model.fundedHours)
    };

    this.$http.post(
      `${this.$rootScope.apiHost}/api/admin/projects/${this.project.id}/funding/breakdown/pair`,
      payload,
      { withCredentials: true }
    ).then((success) => {
      this.toastr.success('Labor and fee funding lines created');
      this.$uibModalInstance.close(success.data);
    }, (failure) => {
      const message = (failure && failure.data && failure.data.message) || 'Failed to create funding pair';
      this.toastr.error(message, 'ERROR');
    }).finally(() => {
      this.saving = false;
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss();
  }
}

export default AddFundingPairModalController;



// WEBPACK FOOTER //
// ./client/common/modals/addFundingPairModal/addFundingPairModal.controller.js